import { AdherenceLogEventType } from '../../../../api/events-client/events-client.type';
import type { FilterGroup } from '../../../../components/filters/filter-panel.type';
import { formatEventType, getEventTypeIcon } from '../components/adherence-logs-table.helpers';

/**
 * Creates event type filter options with appropriate icons and labels
 *
 * @returns Array of event type filter options
 */
const getEventTypeOptions = () => {
  return Object.values(AdherenceLogEventType).map((type) => {
    const { name, color } = getEventTypeIcon(type);
    return {
      value: type,
      label: formatEventType(type),
      icon: {
        name,
        color,
      },
    };
  });
};

/**
 * Generates filter groups for adherence logs
 *
 * @param {string[]} eventTypeFilters - The filter state from useAdherenceLogsFilters hook
 * @param {function} setEventTypeFilters - The setEventTypeFilters function from useAdherenceLogsFilters hook
 * @returns {FilterGroup[]} Array of filter groups
 */
const getFilterGroups = (
  eventTypeFilters: string[],
  setEventTypeFilters: (values: string[]) => void,
): FilterGroup[] => {
  const eventTypeOptions = getEventTypeOptions();

  return [
    {
      name: 'Event Type',
      icon: 'filter_list',
      options: eventTypeOptions,
      selectedValues: eventTypeFilters,
      onSelectionChange: setEventTypeFilters,
    },
  ];
};

export { getFilterGroups };
